import { Loader2 } from "lucide-react";
import { ToolHeader } from "./tools/ToolHeader";
import { ToolList } from "./tools/ToolList";
import { useToolsData } from "./tools/useToolsData";
import { useToolActions } from "./tools/useToolActions";

export const ToolsManagement = () => {
  const { data: tools = [], isLoading, refetch } = useToolsData();
  const {
    isDeleting,
    isDialogOpen,
    setIsDialogOpen,
    editingTool,
    setEditingTool,
    handleDelete,
    handleSubmit,
    handleEdit,
  } = useToolActions(refetch);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ToolHeader
        onToolSubmit={handleSubmit}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        editingTool={editingTool}
        setEditingTool={setEditingTool}
      />

      <ToolList 
        tools={tools}
        onEdit={handleEdit}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />
    </div>
  );
};